import React from 'react';
import type { Props } from '@peloton/flyout';
import PelotonFlyout from '@peloton/flyout';
import CloseIconContainer from './CloseIconContainer';

const Flyout = ({
  children,
  isOpen,
  backgroundColor,
  handleRequestClose,
  ariaLabel,
  ...props
}: Props) => {
  const handleCloseAndShiftDriftChat = handleRequestClose
    ? () => {
        handleRequestClose();
      }
    : undefined;

  return (
    <PelotonFlyout
      handleRequestClose={handleCloseAndShiftDriftChat}
      isOpen={isOpen}
      ariaLabel={ariaLabel}
      backgroundColor={backgroundColor}
      {...props}
    >
      <>
        {children}
        {handleRequestClose ? (
          <CloseIconContainer
            backgroundColor={backgroundColor}
            onCloseClick={handleCloseAndShiftDriftChat}
          />
        ) : null}
      </>
    </PelotonFlyout>
  );
};

export default Flyout;
